module.exports = __webpack_public_path__ + "static/media/location.9feaa4ac.png";